import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { QUERY_KEY } from '~common';
import { getRequest } from '~services';
import { StationInformation } from '~types/station.type';

type ReqParams = {
  box: string;
};

export const useQueryGetStationInformation = (
  reqParams: ReqParams,
  options?: Omit<
    UseQueryOptions<
      StationInformation,
      AxiosError<Record<string, string>>,
      StationInformation,
      (QUERY_KEY | string)[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const fetcher = (): Promise<StationInformation> =>
    getRequest({
      path: 'api/station/v2/info',
      params: {
        imeiOrSerialNumber: reqParams.box,
        requestStationAvailability: true,
      },
    });

  return useQuery(
    [QUERY_KEY.GET_STATION_INFORMATION, reqParams.box],
    () => fetcher(),
    options,
  );
};
